var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaudAiIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83302 1.3335C4.29325 1.3335 4.66635 1.70659 4.66635 2.16683V3.00017H5.49969C5.95993 3.00017 6.33302 3.37327 6.33302 3.8335C6.33302 4.29374 5.95993 4.66684 5.49969 4.66684H4.66635V5.50018C4.66635 5.96041 4.29325 6.33351 3.83302 6.33351C3.37278 6.33351 2.99968 5.96041 2.99968 5.50018V4.66684H2.16634C1.70611 4.66684 1.33301 4.29374 1.33301 3.8335C1.33301 3.37327 1.70611 3.00017 2.16634 3.00017H2.99968V2.16683C2.99968 1.70659 3.37278 1.3335 3.83302 1.3335ZM3.83302 9.66685C4.29325 9.66685 4.66635 10.04 4.66635 10.5002V11.3335H5.49969C5.95993 11.3335 6.33302 11.7066 6.33302 12.1669C6.33302 12.6271 5.95993 13.0002 5.49969 13.0002H4.66635V13.8335C4.66635 14.2938 4.29325 14.6669 3.83302 14.6669C3.37278 14.6669 2.99968 14.2938 2.99968 13.8335V13.0002H2.16634C1.70611 13.0002 1.33301 12.6271 1.33301 12.1669C1.33301 11.7066 1.70611 11.3335 2.16634 11.3335H2.99968V10.5002C2.99968 10.04 3.37278 9.66685 3.83302 9.66685Z",
    fill: "url(#paint0_linear_19502_26342)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66632 1.3335C10.0444 1.3335 10.3752 1.58807 10.4719 1.95359L11.4546 5.66595L14.2494 7.27836C14.5074 7.42719 14.6663 7.70237 14.6663 8.00018C14.6663 8.298 14.5074 8.57318 14.2494 8.72201L11.4546 10.3344L10.4719 14.0468C10.3752 14.4123 10.0444 14.6669 9.66632 14.6669C9.28821 14.6669 8.95749 14.4123 8.86073 14.0468L7.87805 10.3344L5.08325 8.722C4.82528 8.57318 4.66635 8.298 4.66635 8.00018C4.66635 7.70237 4.82528 7.42719 5.08325 7.27836L7.87805 5.66595L8.86073 1.95359C8.95749 1.58807 9.28821 1.3335 9.66632 1.3335Z",
    fill: "url(#paint1_linear_19502_26342)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19502_26342",
    x1: -0.5,
    y1: -1.5,
    x2: 14.5,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.102631,
    stopColor: "#90A745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F04F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19502_26342",
    x1: -0.5,
    y1: -1.5,
    x2: 14.5,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.102631,
    stopColor: "#90A745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F04F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaudAiIcon);
export default __webpack_public_path__ + "static/media/saud-ai-icon.6acb69b6dd5d6a807a67ca475d09effd.svg";
export { ForwardRef as ReactComponent };